import { FCX } from "@models";
import { ReactNode } from "react";
import { FloatInput } from "@components/Inputs/FloatInput";

export type OptionToRender = {
    id?: string | number;
    title: string;
    value: number;
    isEditable?: boolean;
};

const Options: FCX<{
    data: OptionToRender[];
    title: ReactNode;
    onItemChange: (_value: string, _id: OptionToRender["id"]) => void;
}> = ({
    data,
    title,
    onItemChange,
}) => {
    return (
        <div className="SurveyDetails__param-column">
            <div className="SurveyDetails__section-title">{title}</div>
            {data.map(o => (
                <div key={o.id} className="SurveyDetails__param-row">
                    <div className="SurveyDetails__param-title">{o.title}</div>
                    <div className="SurveyDetails__param-value text-input">
                        <FloatInput
                            value={`${o.value ?? ''}`}
                            setValue={(value) => {
                                onItemChange(value, o.id);
                            }}
                            isSmall
                        />
                        &nbsp;%
                    </div>
                </div>
            ))}
        </div>
    );
}

export default Options;